<template>
  <v-row>
    <v-col cols="12" class="py-0">
      <v-row no-gutters class="title grey--text text--darken-2 font-weight-regular mb-0 d-flex align-center">
        <v-col cols="auto" class="mb-1 mb-sm-0">
          <v-icon class="line-height-0" size="25" color="grey darken-2" left>mdi-finance</v-icon>
          <span class="mr-4">{{$t('ISTATISTIKLER.DASHBOARD.GENERAL_STATS.TITLE')}}</span>
        </v-col>
        <v-col cols="auto" class="d-flex align-center">
          <v-btn-toggle
              v-model="statsLimit"
              mandatory
              color="white"
              background-color="grey lighten-2"
          >
            <v-btn
                :color="statsLimit === `today` ? `grey darken-4` : ''"
                :value="`today`"
                x-small
            >{{$t('ISTATISTIKLER.DASHBOARD.GENERAL_STATS.DATE_RANGES.TODAY')}}</v-btn>
            <v-btn
                :color="statsLimit === `1 Week` ? `grey darken-4` : ''"
                :value="`1 Week`"
                x-small
            >{{$t('ISTATISTIKLER.DASHBOARD.GENERAL_STATS.DATE_RANGES.THIS_WEEK')}}</v-btn>
            <v-btn
                :color="statsLimit === `1 Month` ? `grey darken-4` : ''"
                :value="`1 Month`"
                x-small
            >{{$t('ISTATISTIKLER.DASHBOARD.GENERAL_STATS.DATE_RANGES.ONE_MONTH')}}</v-btn>
            <v-btn
                :color="statsLimit === `3 Months` ? `grey darken-4` : ''"
                :value="`3 Months`"
                x-small
            >{{$t('ISTATISTIKLER.DASHBOARD.GENERAL_STATS.DATE_RANGES.THREE_MONTHS')}}</v-btn>
          </v-btn-toggle>
        </v-col>
      </v-row>
      <v-divider class="d-none d-md-block"></v-divider>
    </v-col>
    <v-col cols="12" lg="3" md="6" sm="6">
      <v-card class="statistics-card" height="120px" color="primary">
        <div class="statistics-container px-3 py-4">
          <p class="white--text display-1 font-weight-light">
            <span class="d-block mb-2">
              <v-sheet
                dark
                class="statistic-sheet d-inline-block rounded-lg px-3 py-1"
                color="purple darken-2"
              >
                <span class="darken-1">{{$t('ISTATISTIKLER.DASHBOARD.GENERAL_STATS.CARDS.USERS_TITLE')}}</span>
              </v-sheet>
            </span>
            <span class="px-2">
              <v-progress-circular
                v-if="statsProgress.Kullanicilar"
                :size="40"
                color="white"
                absolute
                indeterminate
              ></v-progress-circular>
              <b v-else>{{statsCount.Kullanicilar}}</b>
            </span>
          </p>
        </div>
        <v-icon color="white" size="130" class="statistics-icon">mdi-account-plus</v-icon>
      </v-card>
    </v-col>
    <v-col cols="12" lg="3" md="6" sm="6">
      <v-card class="statistics-card" height="120px" color="primary">
        <div class="statistics-container px-3 py-4">
          <p class="white--text display-1 font-weight-light">
            <span class="d-block mb-2">
              <v-sheet
                dark
                class="statistic-sheet d-inline-block rounded-lg px-3 py-1"
                color="orange darken-4"
              >
                <span>{{$t('ISTATISTIKLER.DASHBOARD.GENERAL_STATS.CARDS.ORDERS_TITLE')}}</span>
              </v-sheet>
            </span>
            <span class="px-2">
              <v-progress-circular
                v-if="statsProgress.Siparisler"
                :size="40"
                color="white"
                absolute
                indeterminate
              ></v-progress-circular>
              <b v-else>{{statsCount.Siparisler}}</b>
            </span>
          </p>
        </div>
        <v-icon color="white" size="110" class="statistics-icon icon-two">mdi-bell-ring</v-icon>
      </v-card>
    </v-col>
    <v-col cols="12" lg="3" md="6" sm="6">
      <v-card class="statistics-card" height="120px" color="primary">
        <div class="statistics-container px-3 py-4">
          <p class="white--text display-1 font-weight-light">
            <span class="d-block mb-2">
              <v-sheet
                dark
                class="statistic-sheet d-inline-block rounded-lg px-3 py-1"
                color="blue darken-2"
              >
                <span class="darken-1">{{$t('ISTATISTIKLER.DASHBOARD.GENERAL_STATS.CARDS.VISITORS_TITLE')}}</span>
              </v-sheet>
            </span>
            <span class="px-2">
              <v-progress-circular
                v-if="statsProgress.Ziyaretciler"
                :size="40"
                color="white"
                absolute
                indeterminate
              ></v-progress-circular>
              <b v-else>{{statsCount.Ziyaretciler}}</b>
            </span>
          </p>
        </div>
        <v-icon color="white" size="130" class="statistics-icon">mdi-account-group</v-icon>
      </v-card>
    </v-col>
    <v-col cols="12" lg="3" md="6" sm="6">
      <v-card class="statistics-card" height="120px" color="primary">
        <div class="statistics-container px-3 py-4">
          <p class="white--text display-1 font-weight-light">
            <span class="d-block mb-2">
              <v-sheet
                dark
                class="statistic-sheet d-inline-block rounded-lg px-3 py-1"
                color="green darken-2"
              >
                <span class="darken-1">{{$t('ISTATISTIKLER.DASHBOARD.GENERAL_STATS.CARDS.DELIVERY_TITLE')}}</span>
              </v-sheet>
            </span>
            <span class="px-2">
              <v-progress-circular
                v-if="statsProgress.Teslimatlar"
                :size="40"
                color="white"
                absolute
                indeterminate
              ></v-progress-circular>
              <b v-else>{{statsCount.Teslimatlar}}</b>
            </span>
          </p>
        </div>
        <v-icon
          color="white"
          size="130"
          class="statistics-icon icon-four"
        >mdi-package-variant-closed</v-icon>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import IstatistiklerService from "@/services/IstatistiklerService";
export default {
  name: "Statistics",
  data() {
    return {
      boxes: {
        one: {
          primary: "red darken-2",
          icon: "list-status",
          iconColor: "red lighten-1"
        }
      },
      statsProgress: {},
      statsCount: {
        Kullanicilar: null,
        Siparisler: null,
        Teslimatlar: null,
        Ziyaretciler: null
      },
      statsLimit: "today",
      statsModules: {
        Kullanicilar: {
          moduleName: "Kullanicilar",
          statsName: "kullanicilarStats"
        },
        Siparisler: {
          moduleName: "Siparisler",
          statsName: "siparislerStats"
        },
        Teslimatlar: {
          moduleName: "Siparisler",
          statsName: "siparisTeslimatStats"
        },
        Ziyaretciler: {
          moduleName: "Istatistikler",
          statsName: "staticticsStats"
        }
      }
    };
  },
  watch: {
    statsLimit: {
      handler(val) {
        for (let m in this.statsModules) {
          this.$set(this.statsProgress, m, true);
          let { moduleName, statsName } = this.statsModules[m],
            stats = val;

          IstatistiklerService.getModuleStatsCount({
            moduleName,
            statsName,
            stats
          })
            .then(res => {
              if (res.status === 200) {
                this.$set(this.statsCount, m, res.data);
              } else {
                this.$set(this.statsCount, m, "?");
              }
            })
            .then(() => {
              this.$set(this.statsProgress, m, false);
            });
        }
      },
      immediate: true
    }
  }
};
</script>

<style>
.statistics-card {
  position: relative;
  /* background-image: url('../../../src/assets/dot-grid.png'); */
}
.statistics-card:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    -45deg,
    transparent 0%,
    #ffffff00 50%,
    #ffffff14 50%
  );
}
.statistics-card .statistics-container {
  position: relative;
  z-index: 2;
}
.statistics-card .statistic-sheet {
  padding: 0.1rem 1.2rem !important;
  font-weight: 300;
  font-size: 1.86rem;
  letter-spacing: 1px;
  color: #f5f5f5;
}
.statistics-card .statistics-icon {
  position: absolute;
  right: 0;
  bottom: -20px;
  opacity: .2;
}
.statistics-card .statistics-icon.icon-two {
  bottom: -2px;
}
.statistics-card .statistics-icon.icon-four {
  bottom: -10px;
}
</style>

<style scoped>
.line-height-0 {
  line-height: 0;
}
</style>